export default __webpack_public_path__ + "static/media/avatar.d068aa48.svg";